import React from 'react';

const UserGuidePage = React.lazy(() => import('pages/UserGuide/UserGuidePage'));

const userGuideRoute = [
  {
    path: '/user-guide',
    exact: true,
    name: 'Hướng dẫn sử dụng',
    component: UserGuidePage,
  },
];

export default userGuideRoute;
